import type { RouteObject } from 'react-router';
import { IngredientDetailPage } from './IngredientDetailPage';
import { IngredientsPage } from './IngredientsPage';

/** Routes for the ingredients area (mounted inside RequireHousehold). */
export const ingredientsRoutes: RouteObject[] = [
  { path: '/ingredients', element: <IngredientsPage /> },
  { path: '/ingredients/:id', element: <IngredientDetailPage /> },
];
